import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';

const propTypes = {
  text: PropTypes.string,
  isMultilineText: PropTypes.array,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  iconSize: PropTypes.oneOf(['1x', '2x', '3x', '4x', '5x']),
  iconType: PropTypes.oneOf(['spinner', 'spinnerWithPulse', 'circle', 'refresh', 'cog', 'progressBar']),
  className: PropTypes.string,
  style: PropTypes.object,
  progress: PropTypes.number
};

const defaultProps = {
  color: 'white',
  text: 'Loading',
  height: '100%',
  width: '100%',
  iconType: 'spinnerWithPulse',
  iconSize: '3x',
  className: '',
  style: {},
  progress: 0
};

const Loader = (props) => {
  const { iconType, color, width, height } = props;
  const iconClass = {
    spinner: 'fa-spinner',
    circle: 'fa-circle-o-notch',
    refresh: 'fa-refresh',
    cog: 'fa-cog',
    spinnerWithPulse: 'fa-spinner fa-pulse'
  };

  const styles = StyleSheet.create({
    dataLoader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexFlow: 'column',
      color: color,
      width: width,
      height: height
    },
    progressBar: {
      width: '300px',
      height: '20px',
      background: '#f0f0f0',
      borderRadius: '10px'
    },
    progress: {
      width: `${props.progress}%`,
      height: '100%',
      background: '#4CAF50',
      borderRadius: '10px',
      transition: 'width 0.3s ease-in-out'
    }
  });

  return (
    <div
      className={`${props.className} ${css(styles.dataLoader)}`}
      style={{ ...props.style }}
    >
      {props.iconType !== 'progressBar' &&
        <i className={`fa ${iconClass[iconType]} fa-spin fa-${props.iconSize} fa-fw`} />
      }
      {props.iconType === 'progressBar' &&
        <div className={css(styles.progressBar)}>
          <div className={css(styles.progress)} />
        </div>
      }
      {!props.isMultilineText &&
        <div>{props.text}</div>
      }
      {props.isMultilineText &&
        props.text.map((el, idx) => (
          <div key={`${el.substring(0, 3)}__${idx}`}>
            {el}
          </div>
        ))
      }
    </div>
  );
};

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;

export { Loader };
